module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-container"
  }, [_c('p', {
    staticClass: "footer-copyright"
  }, [_c('span', [_vm._v("CopyRight © 2019 ThinkinPower, ALL RIGHT RESERVED. ")]), _c('a', {
    attrs: {
      "href": "http://www.miitbeian.gov.cn",
      "target": "_blank"
    }
  }, [_vm._v("粤ICP备16101578号")]), (_vm.$env.env !== 'prod') ? _c('span', {
    staticClass: "env"
  }, [_vm._v(_vm._s(_vm.$env.name))]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53f97a2d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer.vue
// module id = 556
// module chunks = 5